<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <div class="primary--text font-weight-medium text-h5">
          {{ $t('title_cap_payment') }}
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-card v-if="payments">
          <v-card-title>
            <span class="headline primary--text font-weight-regular">
              {{ $t('title_pay_history') }}
            </span>
          </v-card-title>
          <v-card-subtitle>
            <v-list-item class="pl-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-information-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>
                <span>
                  {{ $t('title_pay_how_policy') }}
                </span>
              </v-list-item-subtitle>
            </v-list-item>
          </v-card-subtitle>
          <v-container class="pt-0">
            <v-list-item
              v-for="(bill, i) in $store.state.bill.bills"
              :key="i"
              class="mb-1 grey lighten-4"
            >
              <v-list-item-content>
                <v-list-item-title class="text--primary">
                  {{ bill.invoiceId }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ bill.period }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  $ {{ bill.payment.total }}
                  {{ bill.payment.paid ? 'Paid' : 'Unpaid' }}
                  {{ bill.payment.method ? `vai ${bill.payment.method}` : '' }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-card-text class="py-0">
                  {{
                    bill.computedPaymentTimestamp
                      ? bill.computedPaymentTimestamp
                      : ''
                  }}
                </v-card-text>
                <!--                <v-card-text class="py-0">-->
                <!--                  <a :href="bill.invoiceLink">-->
                <!--                    {{$t('btn_cap_receipt')}}-->
                <!--                  </a>-->
                <!--                </v-card-text>-->
              </v-list-item-action>
            </v-list-item>
          </v-container>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <span class="headline primary--text font-weight-regular">
              {{ $t('title_cap_pay_how') }}
            </span>
            <v-spacer></v-spacer>
            <span class="subtitle-2">
              {{ $t('title_txt_card_tip') }}
            </span>
          </v-card-title>
          <v-card-subtitle>
            <v-list-item class="pl-0">
              <v-list-item-icon>
                <v-icon class="primary--text">mdi-information-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>
                {{ $t('title_pay_how_policy') }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-card-subtitle>
          <v-container class="pt-0">
            <v-card v-for="term in terms" :key="term.title" flat>
              <v-card-title>
                {{ term.title }}
              </v-card-title>
              <v-card-text>
                <div
                  v-for="(element, i) in term.elements"
                  :key="i"
                  class="pa-1"
                >
                  {{ i + 1 }}. {{ element }}
                </div>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12" order="2" order-md="1" class="pt-0">
            <v-card>
              <v-card-title class="mx-auto primary--text pb-0">
                {{ $store.getters['bill/lastBill'].period }}
              </v-card-title>
              <v-card-text class="pb-0 pt-3">
                <v-icon>mdi-domain</v-icon>
                <span class="pl-1">
                  {{ $t('btn_cap_all_branches') }}
                </span>
              </v-card-text>
              <v-card-text class="pb-0">
                <v-icon>mdi-account</v-icon>
                <span class="pl-1">
                  {{
                    $t('cap_count_unique_customer', {
                      value: $store.getters['bill/lastBill'].totalUsers
                    })
                  }}
                </span>
              </v-card-text>
              <v-card-text>
                <v-icon>mdi-calendar-check</v-icon>
                <span class="pl-1">
                  {{
                    $store.getters['bill/lastBill'].payment.paid
                      ? $t('cap_payment_status_done')
                      : $t('cap_payment_status_undone', {
                          value: $store.getters['bill/lastBill'].payment.total
                        })
                  }}
                </span>
              </v-card-text>
              <!--              <v-card-actions>-->
              <!--                <v-spacer></v-spacer>-->
              <!--                <v-btn text class="red&#45;&#45;text" :href="$store.getters['bill/lastBill'].invoiceLink">-->
              <!--                  {{$t('btn_cap_receipt_down')}}-->
              <!--                </v-btn>-->
              <!--              </v-card-actions>-->
            </v-card>
          </v-col>
          <v-col cols="12" order="3" order-md="2">
            <v-card class="primary">
              <v-card-title class="mx-auto teal--text accent-2 pb-0">
                {{ $t('cap_next_pay_estimate') }}
              </v-card-title>
              <v-card-text class="pb-0 pt-3">
                <v-icon class="white--text">mdi-domain</v-icon>
                <span class="pl-1 white--text">
                  {{ $t('btn_cap_all_branches') }}
                </span>
              </v-card-text>
              <v-card-text class="pb-0">
                <v-icon class="white--text">mdi-calendar</v-icon>
                <span class="pl-1 white--text">
                  {{
                    $store.getters['bill/lastBill'].computedNextInvoiceDate ||
                    'Need Setup'
                  }}
                </span>
              </v-card-text>
              <v-card-text class="pb-0">
                <v-spacer></v-spacer>
                <div class="pl-1 white--text text-h2 text-right">
                  {{ $store.getters['bill/estimateBill'].charge }}
                </div>
              </v-card-text>
              <v-card-text>
                <span class="white--text">
                  {{ $store.getters['bill/estimateBill'].plan }}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" order="1" order-md="3">
            <v-btn block @click="sttChange">
              <span v-if="payments">
                {{ $t('btn_can_see_all_terms') }}
              </span>
              <span v-else>
                {{ $t('btn_can_receipt_down_all') }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      payments: false
    }
  },
  computed: {
    terms() {
      return [
        {
          title: this.$t('cap_pay_how_term'),
          elements: [
            this.$t('cap_pay_how_term_1'),
            this.$t('cap_pay_how_term_2')
          ]
        },
        {
          title: this.$t('cap_pay_how_process'),
          elements: [
            this.$t('cap_pay_how_process_1'),
            this.$t('cap_pay_how_process_2'),
            this.$t('cap_pay_how_process_3')
          ]
        },
        {
          title: this.$t('cap_pay_how_eg'),
          elements: [
            this.$t('cap_pay_how_eg_1'),
            this.$t('cap_pay_how_eg_2'),
            this.$t('cap_pay_how_eg_3'),
            this.$t('cap_pay_how_eg_4')
          ]
        }
      ]
    }
  },
  methods: {
    sttChange() {
      this.payments = !this.payments
    }
  }
}
</script>
